import $ from "jquery";
export function registerAjaxTransport() {
    // we will use our own ajax transport.
    // We will the ajax object to allways return the response as a blob or an arraybuffer.
    // Then, if the response is a json, we will convert form binary to JSON.
    $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
        // check for conditions and support for blob / arraybuffer response type
        if (window["FormData"]
            && ((options.dataType && (options.dataType === "binary"))
                || (options.data && ((window["ArrayBuffer"] && options.data instanceof ArrayBuffer)
                    || (window.Blob && options.data instanceof Blob))))) {
            let xhr;
            return {
                // create new XMLHttpRequest
                send: (headers, callback) => {
                    // setup all variables
                    xhr = new XMLHttpRequest();
                    let url = options.url;
                    let type = options.type;
                    let async = options.async || true;
                    // blob or arraybuffer. Default is blob
                    let dataType = options["responseType"] || "blob";
                    let data = options.data || null as any;
                    let username = options.username || null;
                    let password = options.password || null;

                    xhr.addEventListener("load", () => {
                        let data: any = {};
                        data[options.dataType] = xhr.response;
                        if (xhr.response.type.startsWith("application/json")) {
                            let reader = new FileReader();
                            reader.addEventListener("loadend", (e) => {
                                const responseData = {
                                    json: JSON.parse((e.srcElement as any).result),
                                };
                                callback(xhr.status, xhr.statusText as "success" | "notmodified" | "nocontent" | "timeout" | "error" | "abort" | "parsererror", responseData, xhr.getAllResponseHeaders());
                            });
                            reader.readAsText(xhr.response);
                        } else {
                            // make callback and send data
                            callback(xhr.status, xhr.statusText as "success" | "notmodified" | "nocontent" | "timeout" | "error" | "abort" | "parsererror", data, xhr.getAllResponseHeaders());
                        }
                    });

                    xhr.open(type, url, async, username, password);

                    // setup custom headers
                    // tslint:disable-next-line: forin
                    for (let i in headers) {
                        xhr.setRequestHeader(i, headers[i]);
                    }

                    xhr.responseType = dataType;
                    xhr.send(data);
                },
                abort: () => {
                    xhr.abort();
                },
            };
        }
    });
}
